import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../views/Index.vue";
import Home from "../views/home/Home.vue";
import Second from "../views/second/Second.vue";
import Third from "../views/third/Third.vue";
import HomeUserNotice from "../views/home/HomeUserNotice.vue";
import About from "../views/about/About.vue"
import OurService from "../views/ourservice/OurService.vue";
import OurServiceBank from "../views/ourservice/OurServiceBank.vue";
import OurServiceFixed from "../views/ourservice/OurServiceFixed.vue";
import OurServiceDigital from "../views/ourservice/OurServiceDigital.vue";
import OurServiceAI from "../views/ourservice/OurServiceAI.vue";
import Contact from "../views/contact/Contact.vue";
import NewsCenter from "../views/news/NewsCenter.vue";
import NewsCenterDetails1 from "../views/news/NewsCenterDetails1.vue";
import NewsCenterDetails4 from "../views/news/NewsCenterDetails4.vue";
import NewsCenterDetails3 from "../views/news/NewsCenterDetails3.vue";
import NewsCenterDetails2 from "../views/news/NewsCenterDetails2.vue";
import NewsCenterDetails5 from "../views/news/NewsCenterDetails5.vue";
import NewsCenterDetails6 from "../views/news/NewsCenterDetails6.vue";
import NewsCenterDetails7 from "../views/news/NewsCenterDetails7.vue";
import HomePrivacy from "../views/home/HomePrivacy.vue";
import HomeTerms from "../views/home/HomeTerms.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: { name: "home" },
    component: Index,
    meta: { requiresAuth: true },
    children: [
      //首页
      {
        path: "/home",
        name: "home",
        component: Home,
        meta: {
          requiresAuth: true,
          title: "首页",
          name: "首页",
        },
      },
      {
        path: "/homeUserNotice",
        name: "homeUserNotice",
        component: HomeUserNotice,
        meta: {
          requiresAuth: true,
          title: "主页-关于客户",
          name: "主页-关于客户",
        },
      },
      {
        path: "/homePrivacy",
        name: "homePrivacy",
        component: HomePrivacy,
        meta: {
          requiresAuth: true,
          title: "隐私政策",
          name: "隐私政策",
        },
      },
       {
        path: "/homeTerms",
        name: "homeTerms",
        component: HomeTerms,
        meta: {
          requiresAuth: true,
          title: "使用条款与条件",
          name: "使用条款与条件",
        },
      },
      {
        path: "/about",
        name: "about",
        component: About,
        meta: {
          requiresAuth: true,
          title: "关于我们",
          name: "关于我们",
        },
      },
      {
        path:"/ourService",
        name:"ourService",
        component:OurService,
        meta : {
          requiresAuth: true,
          title: "我们的服务",
          name: "我们的服务",
          },
      },
      {
        path:"/ourServiceBank",
        name:"ourServiceBank",
        component:OurServiceBank,
        meta : {
          requiresAuth: true,
          title: "我们的服务-银行授信担保",
          name: "我们的服务-银行授信担保",
          },
      },
      {
        path:"/ourServiceFixed",
        name:"ourServiceFixed",
        component:OurServiceFixed,
        meta : {
          requiresAuth: true,
          title: "我们的服务-固定资产投资",
          name: "我们的服务-固定资产投资",
          },
      },
      {
        path:"/ourServiceDigital",
        name:"ourServiceDigital",
        component:OurServiceDigital,
        meta : {
          requiresAuth: true,
          title: "我们的服务-数字资产投资",
          name: "我们的服务-数字资产投资",
          },
      },
      {
        path:"/ourServiceAI",
        name:"ourServiceAI",
        component:OurServiceAI,
        meta : {
          requiresAuth: true,
          title: "我们的服务-人工智能应用",
          name: "我们的服务-人工智能应用",
          },
      },
      {
        path:"/contact",
        name:"contact",
        component:Contact,
        meta : {
          requiresAuth: true,
          title: "联系我们",
          name: "联系我们",
          },
      },
            {
        path:"/newscenter",
        name:"newscenter",
        component:NewsCenter,
        meta : {
          requiresAuth: true,
          title: "新闻中心",
          name: "新闻中心",
          },
      },
      {
        path:"/newscenterdetails1",
        name:"newscenterdetails1",
        component:NewsCenterDetails1,
        meta : {
          requiresAuth: true,
          title: "新闻中心-新闻详情1",
          name: "新闻中心-新闻详情1",
          },
      },
            {
        path:"/newscenterdetails2",
        name:"newscenterdetails2",
        component:NewsCenterDetails2,
        meta : {
          requiresAuth: true,
          title: "新闻中心-新闻详情2",
          name: "新闻中心-新闻详情2",
          },
      },

            {
        path:"/newscenterdetails3",
        name:"newscenterdetails3",
        component:NewsCenterDetails3,
        meta : {
          requiresAuth: true,
          title: "新闻中心-新闻详情3",
          name: "新闻中心-新闻详情3",
          },
      },

            {
        path:"/newscenterdetails4",
        name:"newscenterdetails4",
        component:NewsCenterDetails4,
        meta : {
          requiresAuth: true,
          title: "新闻中心-新闻详情4",
          name: "新闻中心-新闻详情4",
          },
      },

            {
        path:"/newscenterdetails5",
        name:"newscenterdetails5",
        component:NewsCenterDetails5,
        meta : {
          requiresAuth: true,
          title: "新闻中心-新闻详情5",
          name: "新闻中心-新闻详情5",
          },
      },

            {
        path:"/newscenterdetails6",
        name:"newscenterdetails6",
        component:NewsCenterDetails6,
        meta : {
          requiresAuth: true,
          title: "新闻中心-新闻详情6",
          name: "新闻中心-新闻详情6",
          },
      },
                  {
        path:"/newscenterdetails7",
        name:"newscenterdetails7",
        component:NewsCenterDetails7,
        meta : {
          requiresAuth: true,
          title: "新闻中心-新闻详情7",
          name: "新闻中心-新闻详情7",
          },
      },

      //第二页
      {
        path: "/second",
        name: "second",
        component: Second,
        meta: {
          requiresAuth: true,
          title: "第二页",
          name: "第二页",
        },
      },
      //第三页
      {
        path: "/third",
        name: "third",
        component: Third,
        meta: {
          requiresAuth: true,
          title: "第三页",
          name: "第三页",
        },
      },
    ],
  },
];
const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});
export default router;
